import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { OfferSelectionCardModel } from '@flocasts/experience-service-types'
import { combineLatest, forkJoin, map, shareReplay } from 'rxjs'
import {
  EXP_NEW_PLANS_PAGE_ID,
  EXP_NEW_PLANS_PAGE_TOP_VERTICALS_ID,
  EXP_NEW_PLANS_PAGE_TOP_VERTICALS_VARIATION_1,
  EXP_NEW_PLANS_PAGE_VARIATION_1
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'
import { SiteIds } from 'src/app/shared/models/site.model'
import { someJoin } from 'src/app/shared/rx-pipes/some-join'
import { ProductService } from 'src/app/shared/services/product.service'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { VerticalService } from 'src/app/singleton-services/vertical.service'

@Component({
  selector: 'flo-offer-selection-card',
  templateUrl: './offer-selection-card.component.html',
  styleUrls: ['./offer-selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferSelectionCardComponent {
  constructor(
    private readonly productService: ProductService,
    private readonly verticalService: VerticalService,
    private readonly experimentService: ExperimentationService
  ) {}

  /**
   * Card displaying offer pricing information
   */
  @Input()
  offer: OfferSelectionCardModel

  /**
   * Indicates if the offer is selected by the user
   */
  @Input()
  isSelected = false

  @Input()
  displayProduct = false

  /**
   * Forces the vertical/mobile card layout to display on all screen sizes
   * Used by the unified layout to match design specifications
   */
  @Input()
  forceVerticalLayout = false

  readonly trackById = trackById

  get isMonthly() {
    return this.offer.heading === 'Monthly Plan'
  }

  public readonly is2025Layout$ = someJoin([
    this.experimentService.isInVariation(EXP_NEW_PLANS_PAGE_ID, EXP_NEW_PLANS_PAGE_VARIATION_1),
    this.experimentService.isInVariation(
      EXP_NEW_PLANS_PAGE_TOP_VERTICALS_ID,
      EXP_NEW_PLANS_PAGE_TOP_VERTICALS_VARIATION_1
    )
  ]).pipe(shareReplay(1))

  public isWrestlingPromoActive$ = combineLatest([
    this.productService.isWrestlingGiftPromoActive$,
    this.verticalService.siteId$
  ]).pipe(
    map(([isWrestlingGiftPromoActive, siteId]) => {
      return isWrestlingGiftPromoActive && siteId === SiteIds.FLOWRESTLING
    })
  )

  public isGwpActive$ = combineLatest([this.productService.isGwpActive$, this.verticalService.siteId$]).pipe(
    map(([isGwpActive, siteId]) => {
      return isGwpActive && siteId === SiteIds.VARSITY
    })
  )
}
